<template>
  <!-- 仓位列表 -->
  <div id="agentPositionList">
    <b-card class="header-top" ref="headerH">
      <div class="header-page-title">
        <div class="title">
          {{ currentPageTitle }}
        </div>
      </div>
      <b-row>
        <b-col lg="9">
          <!--搜索uid-->
          <b-form-group class="find-middle" :label="$t('lanV4.newUid')">
            <b-form-input v-model.trim="searchUid" maxLength="19" placeholder=""></b-form-input>
          </b-form-group>
          <!-- 仓位id -->
          <b-form-group class="find-middle" :label="$t('positionList.id')">
            <b-form-input maxLength="9" v-model.trim="positionId" placeholder=""></b-form-input>
          </b-form-group>
          <!--仓位状态-->
          <b-form-group :label="$t('positionList.status')" class="find-middle">
            <v-select class="find-select" v-model="positionStatus" :options="contractStatusList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>
          <!--合约名称-->
          <b-form-group :label="$t('positionList.contractId')" class="find-middle">
            <v-select class="find-select" v-model="contractId" :options="contractList">
              <div slot="no-options">{{ $t("common.noFind") }}</div>
            </v-select>
          </b-form-group>

          <!-- 开仓时间 -->
          <b-form-group :label="$t('positionList.openTime')" class="find-middle">
            <el-date-picker v-model="dateArray" unlink-panels type="datetimerange" value-format="timestamp"
              range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
              @change="handleChangeDate" :clearable="false" :picker-options="pickerOptions">
            </el-date-picker>
          </b-form-group>
          <!-- 最近变更时间 -->
          <b-form-group class="find-middle">
            <label>
              <el-tooltip placement="top">
                <div slot="content" style="max-width: 200px;">
                  {{ $t("positionList.mtimeTip") }}
                </div>
                <span class="el_tooltip_bor">
                  {{ $t("positionList.mTime") }}</span>
              </el-tooltip>
            </label>
            <div>
              <el-date-picker v-model="dateArrayTwo" unlink-panels type="datetimerange" value-format="timestamp"
                range-separator="-" :start-placeholder="$t('common.startDate')" :end-placeholder="$t('common.endDate')"
                @change="handleChangeDateTwo" :clearable="false" :picker-options="pickerOptions">
              </el-date-picker>
            </div>

          </b-form-group>
        </b-col>
        <b-col lg="3" class="header-right-btn">
          <div class="find-middle find-btnBox">
            <b-button variant="primary" @click="query">
              <!-- <svg class="icon icon-14 icon-search" aria-hidden="true">
                        <use xlink:href="#icon-v4_17"></use>
                      </svg> -->
              {{ $t("common.search") }}</b-button>
            <b-button variant="light" @click="reset">
              <!-- <svg class="icon icon-14 icon-reset" aria-hidden="true">
                        <use xlink:href="#icon-v4_3"></use>
                      </svg> -->
              {{ $t("common.reset") }}</b-button>
          </div>
        </b-col>
      </b-row>
      <!-- 头部分割线 -->
      <div class="header-top-bottom-bor"></div>
    </b-card>
    <b-card class="table-card">
      <div slot="header">
        <div class="table-title float-left">
          <!-- 数据总览 标题 -->
          <span v-if="pages.total > 0">
            {{ $t("el.pagination.total", { total: pages.total }) }}
          </span>
        </div>
        <!-- <v-page
                  class="float-left"
                  v-if="pages.total > 0"
                  :total-rows="pages.total"
                  :perPage="pages.size"
                  :pageOptions="pages.options"
                  :currentPage="pages.page"
                  @initialize="pageChange"
                  layout="total,sizes"
                >
                </v-page> -->
        <!-- 导出 -->
        <b-button v-if="pages.total > 0" class="float-right btn-export" variant="light"
          :class="!isexportIng ? 'lodingSattus' : ''" @click="exports">
          <svg class="icon icon-16" aria-hidden="true">
            <use xlink:href="#icon-v4_6_h"></use>
          </svg>
          {{ exportButtonText }}
          <svg v-if="!isexportIng" class="icon icon-20 btn-loading" aria-hidden="true">
            <use xlink:href="#icon-v4_loading"></use>
          </svg>
        </b-button>
      </div>
      <b-row>
        <b-col class="table-section">
          <el-table :height="$store.state.baseData.tableH" class="table-container" :data="tableList"
            @sort-change="sortChanged" :cell-class-name="addEnClass"
            :default-sort="{ prop: 'totalAmount', order: 'descending' }">
            <template slot="empty">
              <load-skeleton v-show="loading" :columns="6" :rows="10" :haveLeftNumber="false"></load-skeleton>
              <h4 class="common-table-noData" v-show="!loading">
                <img src="../../assets/images/v4_nodata.png" alt="" />
                <div class="noData-text">
                  {{ $t("common.noData") }}
                </div>
              </h4>
            </template>
            <!--  序号 -->
            <!-- <el-table-column prop="sort" align="left" :label="$t('common.sort')">
                        </el-table-column> -->
            <!-- 仓位id -->
            <el-table-column align="left" :label="$t('positionList.id')" prop="positionId" width="100">
              <template slot-scope="scope">
                {{ scope.row.positionId }}
              </template>
            </el-table-column>
            <!-- uid -->
            <el-table-column align="right" :label="$t('lanV4.newUid')" prop="uid" width="130" />
            <!-- 合约 -->
            <el-table-column align="right" :label="$t('common.contract')" prop="contractName" width="250">
              <template slot-scope="scope">
                <span v-if="scope.row.positionSideOrigin === 'BUY'" class="green">{{
                  scope.row.positionSide
                }}</span>
                <span v-if="scope.row.positionSideOrigin === 'SELL'" class="red">{{
                  scope.row.positionSide
                }}</span>
                <span> {{ scope.row.contractName }}</span>
              </template>
            </el-table-column>
            <!-- 仓位状态 -->


            <el-table-column align="right" :label="$t('positionList.status')" prop="positionStatus" width="120">
              <template slot-scope="scope">
                <span v-if="scope.row.positionStatus === 1">{{ $t('positionList.text1') }}</span>
                <span v-else>{{ $t('positionList.text2') }}</span>
              </template>
            </el-table-column>
            <!-- 仓位 -->
            <el-table-column align="right" :label="$t('positionList.volume')" prop="holdVolume" width="130" />
            <!-- 已平仓位 -->
            <el-table-column align="right" :label="$t('positionList.closeVolume')" prop="closeVolume" width="180" />
            <!-- 累计盈亏 -->
            <el-table-column align="right" :label="$t('positionList.historyRealizedAmount')" prop="sumPnl" width="200">
              <template slot-scope="scope">
                <div v-if="Number(scope.row.sumPnl) > 0" class="green">
                  +{{ scope.row.sumPnl }}{{ scope.row.sumPnlMargin }}
                </div>
                <div v-if="Number(scope.row.sumPnl) === 0">
                  {{ scope.row.sumPnl }}{{ scope.row.sumPnlMargin }}
                </div>
                <div v-if="Number(scope.row.sumPnl) < 0" class="red">
                  {{ scope.row.sumPnl }}{{ scope.row.sumPnlMargin }}
                </div>
              </template>
            </el-table-column>
            <!-- 开仓时间 -->
            <el-table-column align="right" :label="$t('positionList.cTime')" prop="openTime" width="180" />
            <!-- 最近变更时间 -->
            <el-table-column align="right" prop="updateTime" width="180">
              <template slot-scope="scope" slot="header">
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 200px">
                    {{ $t("positionList.mtimeTip") }}
                  </div>
                  <span> {{ $t("positionList.mTime") }}</span>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <span class="mar-r-10">{{ scope.row.updateTime }}</span>
              </template>
            </el-table-column>
          </el-table>
        </b-col>
      </b-row>
      <b-row class="mar-t-20">
        <b-col>
          <v-page v-if="pages.total > 0" :total-rows="pages.total" :perPage="pages.size" :pageOptions="pages.options"
            :currentPage="pages.page" @initialize="pageChange"></v-page>
        </b-col>
      </b-row>
    </b-card>

    <!-- 导出10000条提示 -->
    <b-modal v-model="exportsModalShow" :title="$t('exportsModal.text1')" size="md" centered scrollable
      no-close-on-backdrop id="code-modal">
      <div class="body-content">
        <div class="expor-number-tip">
          {{
            $t("exportsModal.text2", {
              pagesTotal: pages.total,
              maxNum: this.exportNumLimit,
            })
          }}
        </div>
      </div>
      <template v-slot:modal-footer>
        <b-button class="coustom-btn" variant="secondary" @click="onReset">{{
          $t("common.cancel")
          }}</b-button>
        <b-button class="coustom-btn" variant="primary" @click="exports('true')"
          :class="!isexportIng ? 'lodingSattus' : ''">
          <template v-if="!isexportIng">
            {{ $t("common.exportIng") }}
          </template>
          <template v-else>
            <!-- 继续导出 -->
            {{ $t("exportsModal.text3") }}
          </template>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import commonMixin from "@/mixin/common/commonMixin";
import { fixD, fixInput, formatTime } from "@/apis/newmethods";
import headerUpdate from "./components/headerUpdate.vue";

export default {
  name: "agentList",
  mixins: [commonMixin],
  components: {
    headerUpdate,
  },
  data() {
    return {
      searchUid: null, // uid
      positionId: null, //仓位id
      positionStatus: null, //仓位状态
      contractList: [], //合约名称
      contractId: null, //合约id
      dateArray: [new Date().getTime() - 86400000 * 7, new Date().getTime()],
      beginDate: null,
      endDate: null,
      beginDateTwo: null,
      endDateTwo: null,
      dateArrayTwo: [new Date().getTime() - 86400000 * 7, new Date().getTime()],
      // 当天之后的时间无法选择
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > window.Date.now();
        },
      },

      pages: {
        page: 1, // 当前页数
        size: 10, // 页数大小
        options: [10, 40, 60, 100], // 页数大小选择
        total: 0, // 总页数
      },
      notData: true,
      loading: true,
      tableList: [],
      modalShow: false,
      isexportIng: true,
      sortBy: null, //预先排序的字段
      sortDesc: true, //预先降序
      sortName: "totalAmount", //默认排序字段
      sortSet: 1, //默认倒序
      modalType: null,
    };
  },
  computed: {
    exportButtonText() {
      if (!this.isexportIng) {
        return this.$t("common.exportIng"); // '正在导出'
      }
      return this.$t("common.export");
    },
    contractStatusList() {
      return [
        { label: this.$t("common.all"), value: null }, //全部
        { label: this.$t("positionList.text1"), value: 1 }, //持有中
        { label: this.$t("positionList.text2"), value: 0 }, //已平仓
      ];
    },
  },
  watch: {
    pid(v) {
      if (v) {
        this.$nextTick(() => {
          this.pid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    searchUid(v) {
      if (v) {
        this.$nextTick(() => {
          this.searchUid = fixInput(v, 0, { num: 1 });
        });
      }
    },
    positionId(v) {
      if (v) {
        this.$nextTick(() => {
          this.positionId = fixInput(v, 0, { num: 1 });
        });
      }
    },
  },
  created() {
    this.handleChangeDate();
    this.handleChangeDateTwo();
    this.getContractName();
    this.positionStatus = this.contractStatusList[0];
    this.contractId = this.contractList[0];
  },
  methods: {
    // 选择时间
    handleChangeDate() {
      this.beginDate = this.dateArray[0];
      this.endDate = this.dateArray[1];
    },
    // 选择时间
    handleChangeDateTwo() {
      this.beginDateTwo = this.dateArrayTwo[0];
      this.endDateTwo = this.dateArrayTwo[1];
    },

    // 英文数字字体
    addEnClass({ row, column }) {
      switch (column.property) {
        case "uid":
          return "enNum";
        case "pid":
          return "enNum";
        case "tradeAmount":
          return "enNum";
        case "fee":
          return "enNum";
        case "returnAmount":
          return "enNum";
      }
    },
    // 排序变化
    sortChanged(ctx) {
      switch (ctx.prop) {
        case "tradeAmount":
          this.sortName = "tradeAmount";
          break;
        case "fee":
          this.sortName = "fee";
          break;
        case "returnAmount":
          this.sortName = "returnAmount";
          break;
      }
      this.sortSet = ctx.order === "descending" ? 1 : 0;
      this.getData();
    },
    // 搜索
    query() {
      this.pages.page = 1;
      this.loading = true;
      this.getData();
    },
    // 重置
    reset() {
      this.searchUid = null;
      this.positionStatus = this.contractStatusList[0];
      this.positionId = null;
      this.contractId = this.contractList[0];
      this.dateArray = [
        new Date().getTime() - 86400000 * 7,
        new Date().getTime(),
      ];
      this.dateArrayTwo = [
        new Date().getTime() - 86400000 * 7,
        new Date().getTime(),
      ];
      this.handleChangeDate();
      this.handleChangeDateTwo();
    },
    // 获取合约名称
    getContractName() {
      const paramsData = {
        brokerId: undefined,
      };
      this.$http({
        url: this.$store.state.url.agent.getAllOpenContract,
        params: paramsData,
        method: "get",
        // apiType: "fe-json-server",
      }).then(({ data, code, msg }) => {
        if (data && code.toString() === "0") {
          let arr = [{ label: this.$t("common.all"), value: null }];
          if (data.length) {
            data.map((item) => {
              arr.push({ label: item.contractOtherName ? item.contractOtherName : item.contractName, value: item.id });
            });
          }
          this.contractList = arr;
          this.contractId = arr[0];
        }
        this.getData();
      });
    },
    // 获取数据列表
    getData() {
      this.loading = true;
      this.tableList = [];
      const paramsData = {
        openStartTime:
          this.dateArray && this.dateArray[0] ? this.beginDate : null, //开仓时间
        openEndTime: this.dateArray && this.dateArray[1] ? this.endDate : null, //开仓时间
        updateStartTime:
          this.dateArrayTwo && this.dateArrayTwo[0] ? this.beginDateTwo : null, //最近变更时间
        updateEndTime:
          this.dateArrayTwo && this.dateArrayTwo[1] ? this.endDateTwo : null, //最近变更时间
        uid: this.searchUid,
        contractId: this.contractId ? this.contractId.value : null,
        positionId: this.positionId,
        positionStatus: this.positionStatus ? this.positionStatus.value : null,
        pageNum: this.pages.page,
        pageSize: this.pages.size,
        isExport: 0,
      };
      this.$http({
        url: this.$store.state.url.agent.positionPage,
        params: paramsData,
        // method: "get",
        // apiType: "fe-json-server",
      })
        .then(({ data, code, msg }) => {
          this.loading = false;
          if (data && code.toString() === "0") {
            this.setData(data);
          } else {
            this.$bus.$emit("alert", { type: "error", message: msg });
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    setData(datas) {
      const { total, records } = datas;
      this.pages.total = total ? total : 0;
      let arr = [];
      if (records && records.length) {
        records.map((item, index) => {
          arr.push({
            sort: (this.pages.page - 1) * this.pages.size + (index + 1), //序号
            positionId: item.positionId, // 仓位id
            uid: item.uid, // UID
            contractName:item.contractName, // 合约
            positionStatus: item.positionStatus, //仓位状态
            positionSide: item.positionSideOrigin === "BUY" ? this.$t("positionList.sideBuy") : this.$t("positionList.sideSell"), //方向
            positionSideOrigin: item.positionSideOrigin, // 方向类型
            holdVolume: item.holdVolume, // 仓位
            closeVolume: item.closeVolume, // 已平仓位
            sumPnl: item.sumPnlAmount, // 累计盈亏
            sumPnlMargin: item.sumPnlMargin,
            openTime: item.openTime ? formatTime(Number(item.openTime)) : "--", // 开仓时间
            updateTime: item.updateTime
              ? formatTime(Number(item.updateTime))
              : "--", // 最近变更时间
          });
        });
      }
      if (arr.length === 0) {
        this.notData = true;
      }
      this.tableList = arr;
    },
    // 导出
    exports(istrue) {
      if (
        istrue !== "true" &&
        this.pages.total &&
        Number(this.pages.total) > this.exportNumLimit
      ) {
        this.exportsModalShow = true;
      } else {
        if (!this.isexportIng) return;
        this.isexportIng = false;
        const paramsData = {
          openStartTime:
            this.dateArray && this.dateArray[0] ? this.beginDate : null, //开仓时间
          openEndTime:
            this.dateArray && this.dateArray[1] ? this.endDate : null, //开仓时间
          updateStartTime:
            this.dateArrayTwo && this.dateArrayTwo[0]
              ? this.beginDateTwo
              : null, //最近变更时间
          updateEndTime:
            this.dateArrayTwo && this.dateArrayTwo[1] ? this.endDateTwo : null, //最近变更时间
          uid: this.searchUid,
          contractId: this.contractId ? this.contractId.value : null,
          positionId: this.positionId,
          positionStatus: this.positionStatus ? this.positionStatus.value : null,
          pageNum: this.pages.page,
          pageSize: this.exportNumLimit,
          isExport: 1,
        };

        this.outExcel(
          this.$store.state.url.agent.positionPage,
          paramsData,
          "increment-api"
        ).then((datas) => {
          if (datas.code === "0") {
            this.$bus.$emit("alert", {
              type: "success",
              message: this.$t("common.exportSuccess"),
            }); // 导出成功
            this.exportsModalShow = false;
            setTimeout(() => {
              this.isexportIng = true;
            }, 500);
          } else {
            this.$bus.$emit("alert", {
              type: "error",
              message: this.$t("common.exportError"),
            }); // 导出失败
          }
        });
      }
    },
    changeModalShow(data) {
      this.modalShow = data;
    },
    changeModalType(data) {
      this.modalType = data;
    },
    onReset() {
      this.exportsModalShow = false;
    },
    // 分页
    pageChange(data) {
      const { page, pageSize } = data;
      this.pages.page = page;
      this.pages.size = pageSize;
      const v = "page";
      this.getData(v);
    },
  },
};
</script>

<style lang="scss">
#agentPositionList {
  .add-tab {
    position: absolute;
    top: 16px;
    right: 26px;
  }

  .custom-control {
    top: 5px !important;
  }
}
</style>